import React, { useState } from "react"
import { useAuth } from "../../hooks/auth"
import { Link } from "react-router-dom"

import {
  FiMenu,
  FiBookOpen,
  FiUsers,
  FiTrello,
  FiLogOut,
  FiDollarSign,
} from "react-icons/fi"
import {
  SidebarContainer,
  SidebarHeader,
  SidebarContent,
  MenuButton,
  SidebarFooter,
  Text,
} from "./style"

const Sidebar: React.FC = () => {
  const [expanded, setExpanded] = useState(false)

  const { user, signOut } = useAuth()

  const toggleSidebar = () => {
    setExpanded(!expanded)
  }

  return (
    <SidebarContainer expanded={expanded}>
      <SidebarHeader expanded={expanded}>
        <FiMenu onClick={toggleSidebar} size={25} />
      </SidebarHeader>

      {expanded ? (
        <div>
          <SidebarContent>
            <Link to="/school-class">
              <MenuButton expanded={expanded}>
                <FiBookOpen size={25} />
                <Text>Turmas</Text>
              </MenuButton>
            </Link>
            <Link to="/students">
              <MenuButton expanded={expanded}>
                <FiUsers size={25} />
                <Text>Alunos</Text>
              </MenuButton>
            </Link>
            <Link to="/absences">
              <MenuButton expanded={expanded}>
                <FiTrello size={25} />
                <Text>Faltas</Text>
              </MenuButton>
            </Link>
            {user.role === "ADMIN" && (
              <Link to="/users">
                <MenuButton expanded={expanded}>
                  <FiDollarSign size={25} />
                  <Text>Usuários</Text>
                </MenuButton>
              </Link>
            )}
          </SidebarContent>

          <SidebarFooter>
            <FiLogOut size={25} onClick={signOut} />
          </SidebarFooter>
        </div>
      ) : (
        <div>
          <SidebarContent>
            <Link to="/school-class">
              <MenuButton expanded={expanded}>
                <FiBookOpen size={25} />
              </MenuButton>
            </Link>
            <Link to="/students">
              <MenuButton expanded={expanded}>
                <FiUsers size={25} />
              </MenuButton>
            </Link>
            <Link to="/absences">
              <MenuButton expanded={expanded}>
                <FiTrello size={25} />
              </MenuButton>
            </Link>
            {user.role === "ADMIN" && (
              <Link to="/users">
                <MenuButton expanded={expanded}>
                  <FiDollarSign size={25} />
                </MenuButton>
              </Link>
            )}
          </SidebarContent>

          <SidebarFooter>
            <FiLogOut size={25} onClick={signOut} />
          </SidebarFooter>
        </div>
      )}
    </SidebarContainer>
  )
}

export default Sidebar
